import { render, staticRenderFns } from "./consulta_campo_text.vue?vue&type=template&id=fdc8acfe&scoped=true&"
import script from "./consulta_campo_text.vue?vue&type=script&lang=js&"
export * from "./consulta_campo_text.vue?vue&type=script&lang=js&"
import style0 from "./consulta_campo_text.vue?vue&type=style&index=0&id=fdc8acfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc8acfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
